import prishni from "../Image/prishni.jpg";
import sudiksha from "../Image/sudiksha.jpg";
import smriti from "../Image/smriti.jpg";
export const MenuListArray2 = [
    {   
        title: 'Home',	
        to: '/',
    },
    {   
        title: 'About',	
        to: '/about',
    },
    // {   
    //     title: 'Contact',	
    //     to: '/contact',
    // },
    {   
        title: 'Prediction',	
        to: '/predictions',
    },
  
]
export const banks=
     [
      {
        "id":1,
        "name": "Nepal  Bank",
        "interestRate": 12.47
      },
      {
        "id":2,
        "name": "Rastriya Banijaya",
        "interestRate": 13.2
      },
      {
        "id":3,
        "name": "Nabil Bank",
        "interestRate": 11.7
      },
      {
        "id":4,
        "name": "Machhapuchchhre Bank",
        "interestRate": 11
      },
      {
        "id":5,
        "name": "Standard Chartered",
        "interestRate": 12.36
      },
      {
        "id":6,
        "name": "Nepal Investment Bank",
        "interestRate": 9.5
      },
      {
        "id":7,
        "name": "Standard Chartered Bank Nepal",
        "interestRate": 11.86
      },
      {
        "id":8,
        "name": "Himalayan Bank",
        "interestRate": 12.3
      },
      {
        "id":4,
        "name": "Prime Bank",
        "interestRate": 10.47
      },
     
      // Add more banks as needed
    ]
    export const Follower=[
      {
      name:"Our Vision",
      description:"Strive for precision and reliability in loan eligibility predictions, enabling users to make well-informed choices."
    },
      {
        name:" Our Mission",
        description:"To empower individuals by providing accurate and accessible loan prediction services, facilitating informed financial decisions."
      },{
        name:"Our Value",
        description:"To become the premier platform for loan prediction services, setting the standard for accuracy, accessibility, and transparency in financial decision-making"
      }
    
  ]
  export const TeamMember=[
    {
    name:"sudikshya",
    facebook:"",
    instagram:"",
    Image:sudiksha
  },
  {
    name:"smriti",
    facebook:"",
    instagram:"",
    Image:smriti
  },
  {
    name:"prishni",
    facebook:"",
    instagram:"",
    Image:prishni
  },
]
  
  